import { uniq } from 'lodash-es';
import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { RELEVANCE_SCORE_TO_NAME } from '@hotjar/recordings/src/constants/relevance';
import { HotjarFilters } from '@hotjar/recordings/src/store/list/types';
import { PLAYBACKS } from '@hotjar/webapp/constants/routes';
import { getRoute } from '@hotjar/webapp/utils/routing';
import { RecommendedWidgetFetchConfig } from '../../RecordingsPage/utils/getOverviewRecordings';
import { ALL_RELEVANCE_VALUES } from '../constants';

export const mapRelevanceScoreValuesToUniqueCategories = (values: number[]): string[] =>
  uniq(values.map((value) => RELEVANCE_SCORE_TO_NAME[value]));

export const navigateToViewAllRecordings = (
  siteId: number,
  { filters, sortBy, relevanceFilter }: RecommendedWidgetFetchConfig,
) => {
  const relevanceFilterToApplyInTheOpenedTab = relevanceFilter || ALL_RELEVANCE_VALUES;
  const relevanceScoreCategories = mapRelevanceScoreValuesToUniqueCategories(
    relevanceFilterToApplyInTheOpenedTab,
  );

  // Overwritting the user's relevance preference purpusefully to display the same amount of recordings in the list
  const savedHotjarFiltersPreferences = LocalStorage.get(
    'hotjarFiltersPreferences',
  ) as HotjarFilters;

  LocalStorage.set('hotjarFiltersPreferences', {
    ...savedHotjarFiltersPreferences,
    relevanceScore: relevanceScoreCategories,
  });
  window.location.href = `${getRoute(PLAYBACKS.LIST.path, {
    siteId,
  })}?sort_by=${sortBy}&filters=${encodeURI(JSON.stringify(filters))}&view=list`;
};
